
export const joinUrlSegments = (urlSegment1: string, urlSegment2: string) : string => {
  return `${removeTrailingSlash(urlSegment1)}/${removeLeadingSlash(urlSegment2)}`;
}

export const removeLeadingSlash = (url: string) : string => {
  if (!url) {
    return url;
  }

  return url.replace(/^\/+/g, '');
}

export const removeTrailingSlash = (url: string) : string => {
  if (!url) {
    return url;
  }

  return url.replace(/\/+$/g, '');
}

export const getContainerFromPathname = (pathname: string): string | undefined => {
  if (pathname.match(/\/login\/(company|person|individual)$/)) {
    return;
  }

  const companyContainerMatch = pathname.match(/\/login\/company\/(\w+)$/);
  if (companyContainerMatch) {
    return companyContainerMatch[1];
  }

  const personContainerMatch = pathname.match(/\/login\/person\/(\w+)$/);
  if (personContainerMatch) {
    return personContainerMatch[1];
  }

  const containerLoginMatch = pathname.match(/\/login\/(\w+)$/);
  if (containerLoginMatch) {
    return containerLoginMatch[1];
  }
};
